import { Font } from "@react-pdf/renderer";
import PoppinsRegular from "../assets/fonts/Poppins/Poppins-Regular.ttf";
import PoppinsItalic from "../assets/fonts/Poppins/Poppins-Italic.ttf";
import PoppinsBold from "../assets/fonts/Poppins/Poppins-Bold.ttf";
import PoppinsBoldItalic from "../assets/fonts/Poppins/Poppins-BoldItalic.ttf";

const registerPoppins = () => {
  Font.register({
    family: 'Poppins',
    fonts: [
      {
        src: PoppinsRegular,
        fontWeight: 400,
        fontStyle: 'normal',
      },
      {
        src: PoppinsItalic,
        fontWeight: 400,
        fontStyle: 'italic',
      },
      {
        src: PoppinsBold,
        fontWeight: 700,
        fontStyle: 'normal',
      },
      {
        src: PoppinsBoldItalic,
        fontWeight: 700,
        fontStyle: 'italic',
      },
    ],
  });
  
  console.log('Poppins fonts registered successfully');
};

export default registerPoppins;